const cueSet1 = [
    {
          "name": "C4",
          "midi": 60,
          "time": 0,
          "velocity": 0.7874015748031497,
          "duration": 9.896896
        },
        {
          "name": "C4",
          "midi": 60,
          "time": 9.896896,
          "velocity": 0.7874015748031497,
          "duration": 9.896896
        },
        {
          "name": "C4",
          "midi": 60,
          "time": 19.793792,
          "velocity": 0.7874015748031497,
          "duration": 9.896896000000002
        },
        {
          "name": "C4",
          "midi": 60,
          "time": 29.690688,
          "velocity": 0.7874015748031497,
          "duration": 9.896895999999998
        },
        {
          "name": "C4",
          "midi": 60,
          "time": 39.587584,
          "velocity": 0.7874015748031497,
          "duration": 9.896895999999998
        },
        {
          "name": "C4",
          "midi": 60,
          "time": 49.48448,
          "velocity": 0.7874015748031497,
          "duration": 9.896895999999998
        }
];

export default cueSet1;
